"use client";

import { useDroppable, UniqueIdentifier } from "@dnd-kit/core";
import { SortableContext, rectSortingStrategy } from "@dnd-kit/sortable";
import { SortableItem } from "./SortableItem";

interface DiscussingAreaProps {
  id: string;
  items: string[]; // Should only contain 0 or 1 item
  imageUrls: Record<string, string>;
  itemNames: Record<string, string>;
  onDeleteItem: (itemId: string) => void;
  activeId?: UniqueIdentifier | null;
  overId?: UniqueIdentifier | null;
  color: typeof DISCUSSING_COLOR;
}

// Gold color from S+ tier
const DISCUSSING_COLOR = {
  label: "#000000",
  background: "#FCD34D",
};

export function DiscussingArea({
  id,
  items,
  imageUrls,
  itemNames,
  onDeleteItem,
  activeId,
  overId,
  color = DISCUSSING_COLOR,
}: DiscussingAreaProps) {
  // Check if we're hovering over this container or its item
  console.log(items);

  // Filter out the actively dragging item to get the actual existing item
  const existingItem = items.find((itemId) => itemId !== activeId);

  // Check if there's a non-dragging item already in the slot
  const hasExistingItem = existingItem != null;

  const { setNodeRef, isOver } = useDroppable({
    id: `${id}-dropzone`, // Use a different ID to avoid conflicts with container logic
    // Don't use disabled - let the parent's handleDragOver prevent the drop
    // This allows isOver to remain true for visual feedback
  });

  // Check if we're hovering over this container or its item
  // Use overId from parent instead of relying on isOver which can flicker
  const isHoveringDiscussing =
    overId === id ||
    overId === `${id}-dropzone` ||
    (overId != null && items.includes(overId as string));
  const isOverContainer = isOver || isHoveringDiscussing;

  return (
    // <div style={{ width: "200px" }}>
    // {/* Label on top */}
    // {/* <div
    //   className="text-center font-bold text-lg py-2 px-4 rounded-t-lg"
    //   style={{
    //     color: DISCUSSING_COLOR.label,
    //     backgroundColor: DISCUSSING_COLOR.background,
    //   }}
    // >
    //   Discussing
    // </div> */}

    // {/* Container with min height matching tier lists */}
    <div
      className="rounded-lg overflow-hidden transition-shadow duration-300 flex"
      style={{
        width: 'calc(var(--tiers-root-size) * 10)',
        minHeight: 'calc(var(--tiers-root-size) * 6.25)',
        backgroundColor: `${color.background}20`,
        border: `2px solid ${color.background}`,
        // borderTop: "none",
        boxShadow:
          isOverContainer && activeId && !hasExistingItem
            ? `0px 2px 10px ${color.background}BB`
            : `0px 2px 6px ${color.background}66`,
        opacity: isOverContainer && hasExistingItem ? 0.5 : 1,
        transition: "opacity 0.2s, box-shadow 0.3s",
      }}
    >
      <div
        className="text-center font-bold"
        style={{
          color: color.background,
          writingMode: "vertical-rl",
          backgroundColor: `${color.background}20`,
          fontSize: 'calc(var(--tiers-root-size) * 1)',
        }}
      >
        DISCUSSING
      </div>
      {/* Drop Zone */}
      <div
        ref={setNodeRef}
        className="relative rounded-md flex-1"
        style={{
          padding: 'calc(var(--tiers-root-size) * 0.75)',
          margin: 'calc(var(--tiers-root-size) * 0.5)',
          backgroundColor:
            isOverContainer && !hasExistingItem
              ? `${color.background}88`
              : `${color.background}22`,
          transition: "background-color 0.2s, border 0.2s",
          border:
            isOverContainer && activeId && !hasExistingItem
              ? `2px solid ${color.background}`
              : "2px solid transparent",
        }}
      >
        <SortableContext items={items} strategy={rectSortingStrategy}>
          <div
            style={{
              minHeight: 'calc(var(--tiers-root-size) * 5)',
            }}
            className="flex items-center justify-center"
          >
            {existingItem && (
              <SortableItem
                key={existingItem}
                id={existingItem}
                imageUrl={imageUrls[existingItem] || null}
                name={itemNames[existingItem] || ""}
                onDelete={() => onDeleteItem(existingItem)}
                deleteIcon="remove"
                deleteLabel="Remove from discussing"
              />
            )}
          </div>
        </SortableContext>
      </div>
    </div>
    // {/* </div> */}
  );
}
